/** @jsx jsx */

import { jsx, Heading } from "theme-ui"

export const Footer = () => (
  <section sx={{mb: 5, mt: 8}}>
    <Heading sx={{textAlign: "center"}}>Refu(SAL/SE/GE) &copy; 2022</Heading>
  </section>
)

